import React, { Component } from 'react'
import './krishak.css';
import SelectedCrop from '../common/crop/SelectedCrop';
import CropDataField from '../common/crop/CropDataField';
import Select from 'react-select';
import Utilities from '../../global/Utilities';
import { ADD_KRISHAK_SCREEN, SYNC_SERVICE, COMMON } from '../../global/Constants';
import SyncServices from '../../providers/SyncServices';

class Cropping extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showHint: true,
            selectedCrops: [],
            cropData: [],
            cropDataList: [],
            fields: {
                total_owned: 0,
                total_leased: 0,
                irrigated: 0,
                rainfed: 0
            },
            allAreaUnits: [],
            selectedUnits: {},
        }
    }

    componentDidMount() {
        this.getAllCrop();
        this.getAllAreaUnit();
        let krishakData = this.props.krishakData;
        if (krishakData) {
            Utilities.LogPrint("componentDidMountCropping123", krishakData);
            var arrayCropDataList = [
                {
                    cropDataName: "Total Owned",
                    key: "total_owned",
                    cropDataId: "1",
                    quantity: krishakData.total_owned,
                },
                {
                    cropDataName: "Total Leased",
                    key: "total_leased",
                    cropDataId: "2",
                    quantity: krishakData.total_leased,
                },
                {
                    cropDataName: "Irrigated",
                    key: "irrigated",
                    cropDataId: "3",
                    quantity: krishakData.irrigated,
                },
                {
                    cropDataName: "Rainfed",
                    key: "rainfed",
                    cropDataId: "4",
                    quantity: krishakData.rainfed,
                },
            ];
            this.setState({
                fields: {
                    total_owned: krishakData.total_owned,
                    total_leased: krishakData.total_leased,
                    irrigated: krishakData.irrigated,
                    rainfed: krishakData.rainfed
                },
                cropDataList: arrayCropDataList,
                selectedCrops: krishakData.krishak_crops_planteds.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }))
            }, () => {
                Utilities.LogPrint("componentDidMountCropping", this.state.selectedCrops);
                this.updateNextButton();
            })
        } else {
            this.setState({
                cropDataList: [
                    {
                        cropDataName: "Total Owned",
                        key: "total_owned",
                        cropDataId: "1",
                        quantity: ""
                    },
                    {
                        cropDataName: "Total Leased",
                        key: "total_leased",
                        cropDataId: "2",
                        quantity: ""
                    },
                    {
                        cropDataName: "Irrigated",
                        key: "irrigated",
                        cropDataId: "3",
                        quantity: ""
                    },
                    {
                        cropDataName: "Rainfed",
                        key: "rainfed",
                        cropDataId: "4",
                        quantity: ""
                    },
                ]
            })
        }
    }

    isInt(n) {
        return Number(n) === n && n % 1 === 0;
    }

    isFloat(n) {
        return Number(n) === n && n % 1 !== 0;
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {

        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields });
        this.updateNextButton();
    };

    handleUnitChange = (field, event) => {
        let selectedUnits = this.state.selectedUnits;
        selectedUnits[field] = event.target.value;
        this.setState({ selectedUnits });
        this.updateNextButton();
    };

    _getUnitSelected(fieldName, defaultValue) {
        const { selectedUnits } = this.state;
        let value = selectedUnits[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    getAllAreaUnit = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_WEIGHT_UNIT, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allAreaUnits: data.map(({ area_unit_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "ASC"
        // });
        // try {
        //     ApiServices.getAllAreaUnit(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const newArrayOfObj = response.data.data.map(({ area_unit_id: value, name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ allAreaUnits: newArrayOfObj });
        //             Utilities.LogPrint("getAllWeightUnit", newArrayOfObj);
        //         } else {
        //             Utilities.LogPrint("getAllWeightUnit", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         Utilities.LogPrint("getAllWeightUnit", error);
        //     });
        // } catch (error) {
        //     Utilities.LogPrint("getAllWeightUnit", error);
        // }
    }


    updateNextButton = () => {

        const { selectedCrops, allAreaUnits } = this.state;
        const newArray = [];
        let totalCropArea = 0;

        for (var i = 0; i < selectedCrops.length; i++) {
            const crop = this._getFieldValue(selectedCrops[i].label, selectedCrops[i].planted_area);
            const unitId = (allAreaUnits !== undefined && allAreaUnits.length !== 0) ? this._getUnitSelected(selectedCrops[i].label, allAreaUnits[0].value) : 1;
            let croptoadd = {
                crop_group_id: selectedCrops[i].crop_group_id,
                planted_area: parseFloat(crop),
                area_unit_id: unitId,
                crop_name: selectedCrops[i].label,
                area_unit_name: "Acres",
                crop_id: selectedCrops[i].value
            }
            newArray.push(croptoadd)
            totalCropArea = totalCropArea + parseFloat(crop);
        }

        const total_owned = parseFloat(this._getFieldValue("total_owned", 0));
        const total_leased = parseFloat(this._getFieldValue("total_leased", 0));
        const irrigated = parseFloat(this._getFieldValue("irrigated", 0));
        const rainfed = parseFloat(this._getFieldValue("rainfed", 0));

        let croppingAreaValidation = (total_owned + total_leased === rainfed + irrigated) && (totalCropArea === total_owned + total_leased);
        Utilities.LogPrint("croppingAreaValidation", total_owned);
        let isEnable = (croppingAreaValidation);

        if (isEnable) {
            var cropping = {
                cropsPlanted: newArray,
                total_owned: total_owned,
                total_owned_area_unit_id: 1,
                total_leased: total_leased,
                total_leased_area_unit_id: 1,
                irrigated: irrigated,
                irrigated_area_unit_id: 1,
                rainfed: rainfed,
                rainfed_area_unit_id: 1,
            };
        }
        this.setState({ showHint: isEnable })

        this.props._handleNextButton(isEnable, cropping, "cropping");
    }

    getAllCrop = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_KRISHAK_CROP, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    cropData: data.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });
        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "DESC"
        // });
        // try {
        //     ApiServices.getAllActiveCrop(body).then(response => {
        //         var status = response.success;
        //         this.props.loaderCallback(false);
        //         if (status) {
        //             const newArrayOfObj = response.data.map(({ crop_id: value, crop_name: label, ...rest }) => ({ value, label, ...rest }));
        //             this.setState({ cropData: newArrayOfObj })
        //             Utilities.LogPrint("getAllApps", this.state.cropData);
        //         } else {
        //             Utilities.LogPrint("getAllApps", response);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getAllApps", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getAllApps", error);
        // }
    }


    handleCropChange = selectedCrops => {
        this.setState({ selectedCrops }, () => {
            this.updateNextButton();
        });
    };

    render() {
        const { isVisible } = this.props;
        const { selectedCrops, allAreaUnits, cropDataList, cropData, showHint } = this.state;
        const selectedCropsListItem = selectedCrops.map((crop, i) =>
            <SelectedCrop handleUnitChange={this.handleUnitChange} allAreaUnits={allAreaUnits} crop={crop} key={i} _handleValueChange={this._handleValueChange} />
        );

        const cropDataListItem = cropDataList.map((data, i) =>
            <CropDataField handleUnitChange={this.handleUnitChange} allAreaUnits={allAreaUnits} data={data} key={i} _handleValueChange={this._handleValueChange} />
        );

        return (
            <div className={isVisible ? "row krishak-tab-body cropping-body" : "row krishak-tab-body cropping-body d-none"}>
                {cropDataListItem}
                <div className="col-lg-12">
                    <div className="dropdown">
                        <label className="font-weight-medium mt-3">{ADD_KRISHAK_SCREEN.INFORMATION_ABOUT_CROPS_PLANTED} *</label>
                        <Select className=" max-w-360"
                            isMulti
                            value={selectedCrops}
                            onChange={this.handleCropChange}
                            options={cropData}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_CROPS_PLANTED}
                            isClearable={true}
                        />
                    </div>
                </div>
                <div className="col-12 col-lg-5">
                    <div className="form-group  d-md-none">
                        <label className="font-weight-medium mt-3" id="width100">{ADD_KRISHAK_SCREEN.INFORMATION_ABOUT_CROPS_PLANTED} *</label>
                        <Select className=" max-w-360"
                            isMulti
                            value={selectedCrops}
                            onChange={this.handleCropChange}
                            options={cropData}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_CROPS_PLANTED}
                            isClearable={true}
                        />
                    </div>
                    {selectedCropsListItem}
                </div>
                <span className={!showHint ? "error-msg" : "d-none error-msg"} >
                    {COMMON.CROPPING_WARNING}
                </span>
            </div>

        )
    }
}

export default Cropping
